import { useEffect, useState } from "react";
import { FlexGrid, Typography, Button, Skeleton, Link, useDialog } from "@albo-ui/core";
import { useRiskCLevel } from "./hooks/useRiskCLevel";
import GeneralConfirmDialog from "../../modals/confirm/GeneralConfirmDialog";
import moment from "moment";
moment.locale("es");
 
export const RiskLevelSection = ({changeAlert, data, lead, handleSectionChange}) => {
    const { loading, check, checkList, afbClevelFind, onRequestAuth, downloadFile } = useRiskCLevel(changeAlert, data, lead, handleSectionChange);
    const dialogProps = useDialog();
    const [element, setElement] = useState(null);
    const [dialogText, setDialogText] = useState({});

    const findItem = (value, catalog) => {
        let find = catalog.filter((i) => i.key === value);
        return find.length > 0 ? find[0]["value"] : value;
    };

    const getName = (data) => {
        let name = "";
        let parts = data.split("/");
        name = parts[parts.length - 1];
        return name;
    };

    const buildElement = (index, label, value, type?, catalog?) => {
        return (
            label && value && (
                <FlexGrid key={index} item container>
                    <Typography variant="paragraph" color="lightNeutral" style={{ width: "30%" }} >
                        {label}
                    </Typography>
                    <Typography variant="paragraph" style={{ width: "60%" }}>
                        {value
                            ? catalog ? findItem(value, catalog)
                                : type === "date" ? moment(value).format("L")
                                : type === "link" ? value.length > 0 ? value.map((item, index) => {
                                        return [
                                            <Link key={`file-${index}`} underlined onClick={downloadFile.bind(this, item)}>{getName(item)}</Link>,
                                            <br key={`file-br-${index}`} />,
                                        ];
                                  }) : "No aplica"
                                : value : "No aplica"}
                    </Typography>
                </FlexGrid>
            )
        );
    };

    const onOpenDialog = () => {
        setElement([
            {type: "textField", label: "Commentarios", key: "reason_request", text: "A continuación puedes indicar el motivo de la solicitud."}
        ]);
        setDialogText({
            title: "Solicitud de Autorización"
        });
        dialogProps.openDialog();
    };

    const onHandleConfirm = (result) => {
        dialogProps.onClose();
        Object.assign(lead, result);
        onRequestAuth(lead);
    };
    const onCloseDialogConfirm = () => {
        dialogProps.onClose();
    };

    useEffect(() => {
        data && data["risk_level"] && afbClevelFind();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return (
        <FlexGrid container direction="column" spacing={1} style={{ marginBottom: 10 }} >
            {loading ? (
                <Skeleton width="100%" height="100px" />
            ) : !data["risk_level"] ? (
                <FlexGrid item style={{ paddingBottom: "0.8rem" }}>
                    <Typography variant="paragraph">
                        El Lead no posee información asociada.
                    </Typography>
                </FlexGrid>
            ) : (
                <>
                    {data && data["risk_level"] &&
                        buildElement(data["risk_level"], "Riesgo:", data["risk_level"])}
                    {check && check["status"] === "assigned"
                        ? buildElement(0, "Estatus:", "En espera C-level")
                        : check &&
                          check["result"] &&
                            checkList.map((item, i) => {
                                return buildElement(
                                    i, item["label"],
                                    item["value"][1] ? check[item["value"][0]][item["value"][1]] : check[item["value"][0]],
                                    item["type"], item["catalog"]
                                );
                            })}
                    {(!check || check["status"] === "assigned") &&
                        lead && (
                            <Button onClick={onOpenDialog.bind(this, lead)} disabled={check} buttonType="secondary" size="normal" style={{ marginTop: 30 }}>
                                Pedir autorización
                            </Button>
                        )}
                </>
            )}
        <GeneralConfirmDialog 
            open={dialogProps.open}
            text={dialogText}
            onClose={onCloseDialogConfirm} 
            onConfirm={onHandleConfirm.bind(this)} 
            item={null}
            element={element}
        />
        </FlexGrid>
    );
};
